import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Training from './pages/Training';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Testimonials from './pages/Testimonials';
import Engagements from './pages/Engagements';
import 'animate.css';
import PopupBanner from './components/PopupBanner';

const App = () => {
  // Load the selected theme from localStorage (if it exists)
  useEffect(() => {
    const savedTheme = localStorage.getItem('selectedTheme') || '/default.css';
    document.getElementById('theme-stylesheet').setAttribute('href', savedTheme);
  }, []);

  return (
    <Router>
      <PopupBanner />
    
      <Navbar />
      <div className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/training" element={<Training />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path='/engagements' element={<Engagements />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/testimonials" element={<Testimonials />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
};

export default App;
